<template>
    <DCard
        padding
    >
        <DTable
            :items="invoicePdfSettingsConfigurations"
            :fields="[
                {key: 'brand_name', label: __('settings.invoice_pdf_settings.index.table.headers.brand_name')},
                {key: 'actions', label: '',_style: { minWidth: '5%' }}
            ]"
            hover
        >
            <template #brand_name="{item}">
                <td>
                    {{ item.brand_name }} ({{ item.language_code }})
                </td>
            </template>
            <template #actions="{item}">
                <td>
                    <div style="display: flex; grid-gap: 10px">
                        <DButton
                            :id="`edit_${item.brand_id}`"
                            mini
                            icon="pencil"
                            @click="$inertia.get(editInvoicePdfSetting(item.brand_id, item.language_code))"
                        />
                        <DButton
                            v-if="item.brand_id"
                            :id="`btn-delete-${item.brand_id}`"
                            mini
                            icon="trash-can-outline"
                            color="danger"
                            :disabled="isInLoadingState"
                            @click="deleteInvoicePdfSetting(item.brand_id, item.brand_name, item.language_code)"
                        />
                    </div>
                </td>
            </template>
        </DTable>

        <DFabs>
            <DFab
                id="btn-add"
                icon="plus"
                :label="__('settings.invoice_pdf_settings.index.add_configuration_button')"
                @click="$inertia.get($route('settings.invoice-pdf-settings.create'))"
            />
        </DFabs>

        <DModal
            v-model:show="showConfirmationModal"
            :title="__('settings.invoice_pdf_settings.index.delete_confirm_modal.title')"
            :message="__('settings.invoice_pdf_settings.index.delete_confirm_modal.message',{brandName: brandNameToDelete})"
            is-confirm
            is-error
            @close="showConfirmationModal = false"
            @confirm="deleteCallBack"
        />
    </DCard>
</template>

<script>
export default {
    name: 'InvoicePdfSettingsIndex',
    props: {
        invoicePdfSettingsConfigurations: {
            type: Array,
            default: () => { return [] }
        }
    },
    data () {
        return {
            showConfirmationModal: false,
            deleteCallBack: () => { return {} },
            brandNameToDelete: ''
        }
    },
    methods: {
        editInvoicePdfSetting (id, languageCode) {
            return this.$route('settings.invoice-pdf-settings.edit', { brand_id: id, language_code: languageCode })
        },
        deleteInvoicePdfSetting (brandId, brandName, languageCode) {
            this.brandNameToDelete = brandName + ' (' + languageCode + ')'
            this.deleteCallBack = () => {
                this.$inertia.delete(this.$route('settings.invoice-pdf-settings.destroy', { brand_id: brandId, language_code: languageCode }))
                this.showConfirmationModal = false
            }
            this.showConfirmationModal = true
        }
    }
}
</script>
